import React from 'react';

import { Urls } from 'js/src/client';
import Callout, { CALLOUT_TYPES } from 'js/src/components/common/ui/Callout';
import { trackUpsellClicked } from 'js/src/libs/analytics-utils';

export const UpgradeToRemoveCreditSceneCallout = React.memo(
    function UpgradeToRemoveCreditSceneCallout() {
        const onUpsellClicked = React.useCallback(() => {
            const context = 'remove_lumen5_branding_prompt';
            trackUpsellClicked(context);
            window.open(Urls.PRICING, '_blank');
        }, []);

        return (
            <div className="upgrade-to-remove-credit-scene-callout">
                <Callout
                    msgType={CALLOUT_TYPES.UPSELL}
                    title="Upgrade to remove Lumen5 branding"
                    ctaText="Upgrade"
                    onCtaClick={onUpsellClicked}
                />
            </div>
        );
    },
);
